import { defaultRequest } from "helpers";

export interface IUser {
  _id?: string;
  email: string;
  firstname?: string;
  lastname?: string;
  role: "admin" | "translator" | "author";
  languages?: string[];
  organisation?: string | { _id: string; name: string };
  language?: string;
  active?: boolean;
  lastAction?: Date;
  creationDate?: Date;
  password?: string;
}

const getUsers = (role?: string) => {
  const params = role ? `?role=${role}` : '';
  return defaultRequest.get<IUser[]>(`users${params}`);
};

const getUserById = (id: string) => defaultRequest.get<IUser>(`users/${id}`);

const addUser = (data: IUser) => defaultRequest.post("auth/signup", data);

const updateUser = (data: IUser) => defaultRequest.post("users", data);

const deleteUsers = (ids: string[]) => defaultRequest.patch("users/delete", { objects: ids });

export const usersApi = {
  getUsers,
  getUserById,
  addUser,
  updateUser,
  deleteUsers,
};

